(function () {
  'use strict';

  function initHsmSlider(root) {
    var track = root.querySelector('[data-hsm-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hsm-slide]'));
    var prevBtn = root.querySelector('[data-hsm-prev]');
    var nextBtn = root.querySelector('[data-hsm-next]');

    if (!track || slides.length === 0) return;

    var activeIndex = Math.floor(slides.length / 2);
    var autoplayInterval = null;
    var autoplayDelay = 3000;

    function render() {
      slides.forEach(function (slide, i) {
        slide.classList.remove('is-active', 'is-prev', 'is-next', 'is-hidden');
        if (i === activeIndex) {
          slide.classList.add('is-active');
        } else if (i === (activeIndex - 1 + slides.length) % slides.length) {
          slide.classList.add('is-prev');
        } else if (i === (activeIndex + 1) % slides.length) {
          slide.classList.add('is-next');
        } else {
          slide.classList.add('is-hidden');
        }
      });
    }

    function goTo(index) {
      activeIndex = (index + slides.length) % slides.length;
      render();
    }

    function startAutoplay() {
      if (slides.length <= 1) return;
      stopAutoplay();
      autoplayInterval = setInterval(function () {
        goTo(activeIndex + 1);
      }, autoplayDelay);
    }

    function stopAutoplay() {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(activeIndex - 1);
        startAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(activeIndex + 1);
        startAutoplay();
      });
    }

    slides.forEach(function (slide, i) {
      slide.addEventListener('click', function (e) {
        if (!slide.classList.contains('is-active')) {
          e.preventDefault();
          goTo(i);
          startAutoplay();
        }
      });
    });

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    render();
    startAutoplay();
  }

  function initAll() {
    var sliders = document.querySelectorAll('[data-hsm-slider]');
    sliders.forEach(function (slider) {
      initHsmSlider(slider.closest('.hsm-section'));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.hsm-section') || (e.target.classList.contains('hsm-section') ? e.target : null);
    if (section) initHsmSlider(section);
  });
})();